<template>
    <div class="checkbox">
        <label>
            <input v-model="checked" type="checkbox" :value="platform.id" class="hidden" />
            <span v-if="checked" :class="platform.icon" style="font-size: 40px;color: #ff00a7;"></span>
            <span v-else :class="platform.icon" style="font-size: 40px;color: #ff00a750;"></span>
        </label>
    </div>
</template>

<script type="text/babel">
export default {
    props: ['platform', 'filteredPlatforms'],

    computed: {
        checked: {
            get() {
                return this.filteredPlatforms.indexOf(this.platform.id) !== -1
            },
            set(value) {
                this.$emit('change', value)
            },
        },
    },
}
</script>
